export const environment = Object.assign({}, {
  apiUrl: 'http://localhost:8010/api',
  staging: false,
  qa: false,
  demo: false,
  prod: false,
  dev: true,
  pwa: true
});
